<i class="fa fa-long-arrow-left inicio ml-1" aria-hidden="true"><a routerLink='/inicio' class="text-left inicio">
    Inicio</a></i>

  <div class="container mb-5 mt-5">

    <div class="row mb-5">
        <div class="col md-12">
            <h1 class="text-center" id="tema-apagar">Apagar tema</h1>
        </div>
    </div>

    <div class="row mb-3">
        <div class="col-md-12">
            <h4 class="text-center">Você tem certeza que deseja apagar esse tema?</h4>
            <h4 class="text-center">Todas as postagens relacionadas a ele serão igualmente apagadas.</h4>
        </div>
    </div>

    <div class="row mb-5">
        <div class="col-md-12">
            <h5 class="text-center" id="tema">Tema: {{tema.descricao}}</h5>
        </div>
    </div>

    <div class="row">
        <div class="col-md-12 d-flex justify-content-center">
            <button routerLink='/tema' class="btn mr-4" id="botao-nao">Não</button>
            <button (click)='apagar()' class="btn btn-danger" id="botao-sim" >Sim</button>

        </div>
    </div>

</div>
